import ReactDOM from 'react-dom/client';
import React from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import EmergencyBanner from '@fec/frontend/modules/emergency-banner/EmergencyBanner.jsx';

export function init() {
  const containers = document.querySelectorAll('.js-emergency-banner');

  containers.forEach((container) => {
    const endpointUrl = container.dataset.endpointUrl ?? '';

    if (!endpointUrl) {
      // eslint-disable-next-line no-console
      console.error('No endpoint URL provided for banner.');
      return;
    }

    const queryClient = new QueryClient();

    ReactDOM.createRoot(container).render(
      <React.StrictMode>
        <QueryClientProvider client={queryClient}>
          <EmergencyBanner endpointUrl={endpointUrl} />
        </QueryClientProvider>
      </React.StrictMode>,
    );
  });
}
